/**
 * Wrapper component to handle checkbox button input fields
 * that use Formik and Reactstrap.
 */
import { FormGroup, Input, Label } from "reactstrap";

/**
 * Formik checkbox button field.
 */
const CheckboxButtonInput = ({
  field,
  meta,
  helpers,
  onChange,
  option,
  optionLabelKey,
  optionValueKey,
  isChecked,
  ...props
}) => {
  const id = `${field.name}-${option[optionValueKey]}`;
  const disabled = props.disabled || option.disabled;
  const invalid = Boolean(meta.touched && meta.error);
  return (
    <FormGroup check inline>
      <Input
        {...props}
        id={id}
        type="checkbox"
        invalid={invalid}
        checked={isChecked}
        disabled={disabled}
        name={field.name}
        onBlur={field.onBlur}
        onChange={onChange}
      />{" "}
      <Label check for={id}>
        {option[optionLabelKey]}
      </Label>
    </FormGroup>
  );
};

export default CheckboxButtonInput;
